import { render, staticRenderFns } from "./OfferLoader.vue?vue&type=template&id=70052282&scoped=true&"
import script from "./OfferLoader.vue?vue&type=script&lang=js&"
export * from "./OfferLoader.vue?vue&type=script&lang=js&"
import style0 from "./OfferLoader.vue?vue&type=style&index=0&id=70052282&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70052282",
  null
  
)

export default component.exports